<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-date-picker
          class="filter-item dp"
          v-model="dateRange"
          @change="handleDateRangeChange"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <auth-select :isEdit="true" type="select" :data-source="[{value:'TL1000',label:'TL1000'},{value:'TL2000',label:'TL2000'}]" v-model="listQuery.domain" :value="listQuery.domain" class="filter-item"></auth-select>
        <el-input size="mini" style="width: 200px;" class="filter-item" :placeholder="'用户账号/uid'" v-model="listQuery.key"> </el-input>
        <el-button class="filter-item" size="mini" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <permission-btn size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <!-- <div class="bg-white" style="height: 100%;" v-if="list && list.length"> -->
        <auth-table
          style="height:calc(100% - 60px)"
          ref="mainTable"
          :select-type="''"
          :table-fields="headerList"
          :data="list"
          :v-loading="listLoading"
          :empty-text="'指定Domain、用户账号/Uid以及时间范围，查看用户事件'"
        ></auth-table>
      </div>
      <!-- <div class="bg-white" style="height: 100%;padding:150px calc(50% - 260px);font-size:20px;" v-else>
        指定Domain、用户账号/Uid以及时间范围，查看用户事件
      </div> -->
    </div>
  </div>
</template>
<script>
import * as events from '@/api/events'
import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import permissionBtn from '@/components/PermissionBtn'
import elDragDialog from '@/directive/el-dragDialog'
import extend from '@/extensions/common.js'
import AuthSelect from '@/components/Base/AuthSelect'
import AuthTable from '../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'
export default {
  name: 'event',
  components: { Sticky, permissionBtn, AuthTable, AuthSelect},
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  data() {
    return {
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      dateRange:[],
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        // 查询条件
        page: 1,
        limit: 20,
        key: undefined,
        domain:undefined,
        start:undefined,
        end:undefined
      },
    }
  },
  created() {
    this.headerList = [
      new ColumnDefine('id', 'ID', false, false, '', '', 'bigint', 'bigint', 'Id'),
      new ColumnDefine('domain', 'Domain', true, true, '', '', 'string', 'varchar', 'domain',100),
      new ColumnDefine('event', '事件', true, true, 'select', 'TalkEventType', 'string', 'varchar', 'Event',120),
      new ColumnDefine('eventTime', '时间', true, true, '', '', 'DateTime', 'datetime', 'EventTime',180),
      new ColumnDefine('uid', 'Uid', true, true, '', '', 'string', 'varchar', 'Uid',100),
      new ColumnDefine('account', '对讲账号', true, true, '', '', 'string', 'varchar', 'Account',200),
      new ColumnDefine('details', '详情', true, true, 'html', '', 'string', 'varchar', 'Details'),
    ]
    //this.getList()
  },
  methods: {
    handleDateRangeChange(value){
      if(value && value.length == 2){
        this.listQuery.start = value[0]
        this.listQuery.end = value[1]
      }
    }, 
    onBtnClicked: function(domId,callback) {
      switch (domId) {
        case 'btnExport':
            this.$refs.mainTable.exportExcel('资源文件',callback)
            break
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      events.getList(this.listQuery).then((response) => {
        this.list = response.result
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
  },
}
</script>
<style scoped>
.dialog-mini .el-select {
  width: 100%;
}

.dp {
  height:28px;
  /deep/ .el-input__inner{
    height:28px;
  }
}

::v-deep .el-table .cell {
  white-space: pre-line; /* 保留空白符序列，但是正常地进行换行 */
  word-break: break-all; /* 可选，用于处理长单词或URL的换行 */
}
</style>